import React from 'react';
import { defineNextPage } from '@/common/next';
import Head from 'next/head';
import styles from './index.module.scss';
import CommunityContent from './CommunityContent';

export default defineNextPage<{
  title: string;
}>({
  pageConfig: {
    projectId: '/--roboneo',
    layoutId: 'RoboneoLayout',
    renderHead({ pageProps }) {
      return (
        <Head>
          <title>RoboNeo</title>
        </Head>
      );
    },
  },
  component: (() => {
    return (
      <div className={styles.container}>
        <CommunityContent />
      </div>
    );
  }),
});
